import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { Field, initialize, reduxForm } from 'redux-form';
import { AddContact } from '../../../actions/contactActions';
import { renderField } from '../../../helpers/FormControls';
import normalizePhone from '../../../helpers/normalizePhone';
import { validate } from './ContactsValidation';

function submit(values) {
   //window.alert(`You submitted:\n\n${JSON.stringify(values, null, 2)}`)
  const formObject={'firstName':'','lastName':'','company':'','phoneNum':'','emailId':'','notes':''}
  var formData = _.extend({}, formObject, values);
  this.props.dispatch(AddContact(formData));
}
class ContactsNew extends Component{
 
   handleClick = () =>{
      this.props.dispatch(initialize('ContactsNewForm'));
  }
   render(){
      const { handleSubmit, pristine, reset, submitting,first_name } = this.props
      return(
         <div className="modal fade addContactModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" style={{width:'638px'}}>
              <form  className="tg-forms" onSubmit={handleSubmit(submit.bind(this))}>
               <div className="modal-content addcontactcontent">
                  <div className="modal-header">
                  <h5 className="modal-title doc-color" id="exampleModalLabel">ADD CONTACT</h5>
                     <button type="button" className="close" id="addcontact" data-dismiss="modal" aria-label="Close" onClick={this.handleClick}>
                        <span aria-hidden="true">&times;</span>
                     </button>
                  </div>
                  <div className="modal-body">
                     <div>
                        <div className="row">
                           <div className="col-md-6">
                              <Field type="text" name="firstName" className="form-control"  controlClass="requiredfield" id="first_name" component={renderField}  label="First Name" />
                           </div>
                           <div className="col-md-6">
                              <Field type="text" name="lastName" className="form-control"  controlClass="requiredfield" id="last_name" component={renderField}  label="Last Name" />
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-md-6">
                             <Field type="text" name="emailId" className="form-control"  controlClass="requiredfield" id="email" component={renderField}  label="Email" />
                           </div>
                           <div className="col-md-6">
                             {/* <label>Phone</label>*/}
                             {/*<div className="row">
                                    <div className="col col-md-2">
                                        <div className="mob-prefix">
                                            <input type="text" name="primaryCountryPhoneCode" maxlength="1" size="1" value="+1" className="text-required"/>
                                        </div>
                                    </div>
                                    <div className="col col-md-10">
                                        <input type="text" className="form-control" name="primaryPhone" id="primaryPhone" />
                                    </div>
                                </div>*/}
                                <Field type="text" className="form-control"  controlClass="requiredfield" normalize={normalizePhone} component={renderField} name="phoneNum" id="primary_phone" label="Primary Phone" />
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-md-6">
                              <Field type="text" name="company" className="form-control" id="company" component={renderField}  label="Company" />
                           </div>
                           <div className="col-md-6">
                              <Field type="text" name="notes" className="form-control" id="notes" component={renderField}  label="Notes" />
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="modal-footer">
                     <button type="submit" className="btn btn-primary btn-sm">Save</button>
                     <button type="button" disabled={pristine || submitting} onClick={reset} className="btn btn-primary btn-sm">Reset</button>
                  </div>
                     
               </div>
               </form>
            </div>
         </div>
         )
   }
}

const mapStateToProps=(state)=>
{
   return{
      loading : state.contactReducer.loading,
      data : state.contactReducer.data
    }
}

export default connect(mapStateToProps)(reduxForm({
   form:'ContactsNewForm',validate
})(ContactsNew))